import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';
import './styles';

import {
  AppButton,
  ButtonContainer,
  MessageBubble,
} from '@/app/shared-components';
import {
  EMessageBubbleSizeVariant,
  EMessageBubbleTailVariant,
  EMessageBubbleToneVariant,
} from '@/app/shared-components/MessageBubble/enums';
import ProgressBar from '@/app/shared-components/ProgressBar/ProgressBar';

import {CPlaidUIAnimation} from './KycPlaidPageConstants';
import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const progressBarDuration = 2000;

const KycPlaidContent = () => {
  const {t} = useTranslation();

  const {
    isReady,
    labelButton,
    isShowPlaidUiLoading,
    labelTitle,
    isShowPlaidUiLoadingError,
    handleGoToVerificationClick,
    handleOnClosePrePlaidModal,
  } = useViewModelProvider();

  return (
    <>
      <Box className="kyc-plaid-container">
        {/* Header Section */}
        <Box className="titles-container">
          <Typography
            variant="h5"
            className="title">
            {labelTitle}
          </Typography>

          {isShowPlaidUiLoading && !isShowPlaidUiLoadingError && (
            <Box className="progress-bar-container">
              <ProgressBar
                value={0}
                onDurationEnds={handleOnClosePrePlaidModal}
                duration={progressBarDuration}
                waitForReady
                isReady={isReady}
              />
            </Box>
          )}
        </Box>

        <Box className="loading-container">
          <MessageBubble
            text={t('kyc.plaid.loading_hint')}
            className="loading-bubble"
            tailVariant={EMessageBubbleTailVariant.Diamond}
            sizeVariant={EMessageBubbleSizeVariant.Md}
            toneVariant={EMessageBubbleToneVariant.Elevated}
          />

          {/* Image Section */}
          <Box className="image-container">
            <Lottie
              className="mdk-lottie"
              animationData={CPlaidUIAnimation}
              loop
              autoplay
            />
          </Box>
        </Box>

        {/* Button Section */}
        {!isShowPlaidUiLoading && (
          <Box className="button-container">
            <ButtonContainer sticky>
              <AppButton
                id="kyc-plaid-go-to-verification-button"
                label={labelButton}
                color="primary"
                // isReady guards the main CTA — button is disabled while Plaid initialises
                disabled={!isReady && !isShowPlaidUiLoadingError}
                isLoading={!isReady && !isShowPlaidUiLoadingError}
                onClick={handleGoToVerificationClick}
              />
            </ButtonContainer>
          </Box>
        )}
      </Box>
    </>
  );
};

const KycPlaidPage = () => (
  <ViewModelProvider>
    <KycPlaidContent />
  </ViewModelProvider>
);

export default KycPlaidPage;
